import { Box } from '@mui/material';
import { Tooltip } from '~/components/Tooltip';
import { DeviceKind } from '~/generated/graphql';
import android from '~/images/android.png';
import brightsign from '~/images/brightsign.png';
import linux from '~/images/linux.png';
import samsung from '~/images/samsung.png';
import webos from '~/images/webos.png';
import { formatDeviceKind } from '~/lib/string';

const LogoImage = ({ alt, img }: { alt: string; img: string }) => {
  return <img alt={alt} src={img} style={{ height: '1.5em' }} />;
};
export interface DeviceLogoProps {
  kind: DeviceKind | undefined;
}

export const DeviceLogo = ({ kind }: DeviceLogoProps) => {
  if (!kind) return null;

  // The logo is the only thing conveying the device kind, so it needs a real name - a tooltip
  // is not a reliable substitute.
  const label = formatDeviceKind(kind);

  return (
    <Tooltip title={label}>
      <Box display="flex">
        {kind === DeviceKind.Android ? (
          <LogoImage alt={label} img={android} />
        ) : kind === DeviceKind.Linux ? (
          <LogoImage alt={label} img={linux} />
        ) : kind === DeviceKind.Brightsign ? (
          <LogoImage alt={label} img={brightsign} />
        ) : kind === DeviceKind.Webos ? (
          <LogoImage alt={label} img={webos} />
        ) : kind === DeviceKind.Samsung ? (
          <LogoImage alt={label} img={samsung} />
        ) : null}
      </Box>
    </Tooltip>
  );
};
